// ----------------------------------------------------------------
// <copyright company='Microsoft Corporation'>
//     Copyright (c) Microsoft Corporation.  All rights reserved.
// </copyright>
// ----------------------------------------------------------------

import React, { useState } from 'react';
import clsx from 'clsx';
import { useTranslation } from 'react-i18next';
import { useSelector, useDispatch } from 'react-redux';
import ShippingMethod, { ShippingMethodPropTypes } from './ShippingMethod';
import Styles from './shippingMethod.module.scss';
import {
    PrimaryButton
} from 'office-ui-fabric-react';
export interface ShippingMethodOffersType {
    readonly?: boolean;
    ishidden?: boolean;
    offers: ShippingMethodPropTypes[];
    isOrderSummaryEditing?: boolean;
    onContinueClick?: () => void;
}

interface HeaderPropTypes {
    shippingMethod: string;
    details: string;
    cost: string;
}
import {
    Progress,
    reActivateOrderStatusSelector,
    updateCreateOrderProgress,
    isOnSiteRepairStatusSelector,
} from './../../store/orderCreation';

export default function ShippingMethodOffers(props: ShippingMethodOffersType) {
    const isOnSiteRepair = useSelector(state => isOnSiteRepairStatusSelector(state));
    const { t } = useTranslation();
    return (
        <section>
            <div className="ms-Grid" dir="ltr"
                style={props.ishidden ? { display: 'none' } : {}} >
                <ShippingMethodHeader
                    shippingMethod={isOnSiteRepair ? t('service_method') : t('shipping_method')}
                    details={t('details')}
                    cost={t('cost')}
                />
                <ShippingMethods {...props} />
            </div>
        </section>
    );
}

function ShippingMethods(props: ShippingMethodOffersType) {
    const [isSubmitting, setSubmitting] = useState(false);
    const dispatch = useDispatch();
    const reActivateOrder = useSelector(state => reActivateOrderStatusSelector(state));

    const { t } = useTranslation();

    function submitContinue() {
        setSubmitting(true);
        if (props.onContinueClick) {
            props.onContinueClick();
        }
        dispatch(updateCreateOrderProgress(Progress.Registration));
    }

    return (
        <>
            {props.offers.map((offer: ShippingMethodPropTypes, index: number) => (
                <ShippingMethod key={index} {...offer} readonly={isSubmitting ? true : props.readonly} isOrderSummaryEditing={props.isOrderSummaryEditing} />
            ))}
            {!isSubmitting && reActivateOrder &&
                <div className="ms-Grid-row">
                    <div className={clsx('ms-Grid-col', 'ms-sm10')} />
                    <div className={clsx('ms-Grid-col', 'ms-sm2')}>
                        <PrimaryButton
                            className={clsx(Styles.buttonPrimary, Styles.buttonAlign, Styles.continueButton)}
                            onClick={submitContinue}
                            ariaLabel={t('continue')}
                            text={t('continue')}
                        />
                    </div>
                </div>
            }
        </>);
}

function ShippingMethodHeader(props: HeaderPropTypes) {

    const { shippingMethod, details, cost } = props;

    return (
        <div className={clsx(Styles.shippingMethod, Styles.dropDown, 'ms-Grid-row', Styles.subHeaders)}>
            <div className={clsx('ms-Grid-col', 'ms-sm5')} >
                {shippingMethod}
            </div>
            <div className={clsx('ms-Grid-col', 'ms-sm6')} >
                {details}
            </div>
            <div className={clsx('ms-Grid-col', 'ms-sm1')} >
                {cost}
            </div>
        </div>);
}